import { designTokens } from "@itandi/itandi-bb-ui";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import { TextLink } from "@itandi/itandi-bb-ui/TextLink";
import type { DealEstimationOcrRequest } from "~/models/DealEstimationOcrRequest";

type Props = {
	backToEditPath: string;
	ocrRequest: DealEstimationOcrRequest;
};

export function SucceededState({ backToEditPath, ocrRequest }: Props) {
	return (
		<Grid
			gap={designTokens["spacing/l"]}
			justifyItems="center"
			minHeight={`calc(100vh - ${designTokens["constants/itandi-header/height"]}px)`}
			placeContent="center"
		>
			<Paragraph>読み取りが完了しました。</Paragraph>
			<TextLink color="link" href={backToEditPath}>
				見積作成画面へ戻る
			</TextLink>
			{/* デバッグ表示 */}
			<pre>{JSON.stringify(ocrRequest.items, null, 2)}</pre>
		</Grid>
	);
}
